export default __webpack_public_path__ + "static/media/file.bf162dd8.svg";